import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'

/**
 * Calls create in the api after submitting a new record
 */
export const submitRecordsOnRequest = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.submitRecord.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.mergeMap(([action, context]) => {
        if (!context) {
          // TODO: handle this differently
          throw new Error('TODO')
        }

        const { record, entityId } = action.data
        // If record.values has no keys we don't submit but rather cancel the request
        if (Object.keys(record.values ?? {}).length === 0) {
          return rxjs.of(
            feature.actions.submitRecord.cancellation.from(action).create({
              request: action.data,
            }),
          )
        }

        return feature.api.create({ ...context, entityId }, record).pipe(
          // Handles success
          rxjs.map(() =>
            feature.actions.submitRecord.success.from(action).create({
              request: action.data,
            }),
          ),
          // Handles error
          rxjs.catchError(error =>
            rxjs.of(
              feature.actions.submitRecord.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        )
      }),
    ),
)
